module.exports = "<template>\n    <pre class=\"multiline-content cm-s-default\" ref=\"preNode\">\n    </pre>\n</template>\n";